export { default } from "./CookieConfirm";